import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { getProject } from '@/src/api/project'
import { useAuth } from '@/src/components/AuthContextProvider'
import { Button } from '@/src/components/ui/button'
import { ProjectEdit } from '@/src/components/manage/projects/ProjectEdit'
import { PERMISSIONS } from '@/permission.config'
import { useTranslation } from '@/src/i18n/client' 

export const Route = createFileRoute('/_manage/manage/projects/$id_/edit')({
  component: ProjectEditPage,
})

function ProjectEditPage() {
  const { t } = useTranslation('manage');
  const { id } = useParams({ from: '/_manage/manage/projects/$id_/edit' })
  const navigate = useNavigate()
  const { permissions, isAdmin } = useAuth()
  
  // Check permission client-side
  useEffect(() => {
    const hasAccess = permissions.includes(PERMISSIONS.PROJECTS_MANAGE) || permissions.includes('*') || isAdmin
    if (!hasAccess) {
      navigate({ to: '/not-permitted' })
    }
  }, [permissions, isAdmin, navigate])

  const { data: project, isLoading } = useQuery({
    queryKey: ['project', 'get', id],
    queryFn: () => getProject({ data: { id } }),
  })

  const handleSaveSuccess = () => {
    navigate({ to: '/manage/projects/$id', params: { id } })
  }

  const handleCancel = () => {
    navigate({ to: '/manage/projects/$id', params: { id } })
  }

  return (
    <div className="flex flex-col h-full">
      <AdminToolbar>
        <AdminToolbar.Left>
          <AdminToolbar.Title>{t('projects.editProject')}</AdminToolbar.Title>
        </AdminToolbar.Left>
        <AdminToolbar.Right>
          <Button variant="outline" size="sm" onClick={handleCancel}>
            {t('cancel')}
          </Button>
        </AdminToolbar.Right> 
      </AdminToolbar>
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-auto">
          <ProjectEdit 
            id={id} 
            isNew={false}
            project={project} 
            isLoading={isLoading} 
            callbackUrl="/manage/projects"
            onSaveSuccess={handleSaveSuccess}
          />
        </div>
      </div>
    </div>
  )
}
